import {localCommand} from "../utils/api";

export const ADD_MANEUVER_TYPE = 'ADD_MANEUVER_TYPE';
export const ADD_MANEUVER_TYPE_SUCCEEDED = 'ADD_MANEUVER_TYPE_SUCCEEDED';
export const ADD_MANEUVER_TYPE_FAILED = 'ADD_MANEUVER_TYPE_FAILED';
export const addManeuverType = localCommand('v1/maneuverType/AddManeuverType', ADD_MANEUVER_TYPE, ADD_MANEUVER_TYPE_SUCCEEDED, ADD_MANEUVER_TYPE_FAILED);